import React, { useEffect, useState } from "react";
import searchIcon from "media/icons/dls/search.svg";
import addIcon from "media/icons/dls/add.svg";
import "./SearchTCCUser.scoped.scss";
import { useDispatch } from "react-redux";
import { setSearchLDAPManageTechContentUsersText } from "store/userManagement/userManagementActions";
import useSelector from "store/useSelector";
import useDebounce from "utilities/useDebounce";
import BlockSpinner from "components/common/BlockSpinner";

interface ISearchTCCUserProps {
    setSelectedUserFunc(email: string): void,
}

const SearchTCCUser: React.FC<ISearchTCCUserProps> = ({ setSelectedUserFunc }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const debouncedSearchTerm = useDebounce(searchTerm, 750);
    const manageUsersData = useSelector(store => store.userManagement.manageTechContentUsersData);
    const { getUsersOperation, ldapUserList } = useSelector(store => store
        .userManagement
        .manageTechContentUsersData);
    const currentUser = useSelector(store => store.auth.currentUser.email);
    const dispatch = useDispatch();
    const [showWarning, setShowWarning] = useState<React.ReactElement | undefined>();
    const [showWarningOptional, setShowWarningOptional] = useState<React.ReactElement | undefined>();

    useEffect(() => {
        dispatch(setSearchLDAPManageTechContentUsersText(debouncedSearchTerm.trim()));
    }, [debouncedSearchTerm, dispatch]);

    let component: React.ReactElement | undefined;
    let titleArea = (<p style={{ color: "darkred" }}>
        You are going to provide access to TCC sensitive content.
        Proceed with caution.
    </p>);

    if (getUsersOperation?.isWorking) {
        component = (
            <BlockSpinner />
        );
    } else if (getUsersOperation?.errorMessage) {
        component = (
            <>
                {titleArea}
                <br />
                <label className="error">
                    {getUsersOperation?.errorMessage}
                </label>
            </>
        );
    } else if (!ldapUserList.length) {
        component = (
            <>
                {titleArea}
                <br />
                <label>No users found.</label>
            </>
        );
    } else {
        component = (
            <>
                {titleArea}
                {ldapUserList.filter(x => x.email !== currentUser).map(r =>
                    <div
                        className="user"
                        key={r.email}
                    >
                        <span>
                            {r.name} ({r.email})
                        </span>
                        <img
                            src={addIcon}
                            className="add-button icon-medium hover-gray-bg"
                            onClick={() => onUserSelect(r.email, r.name)}
                            alt="Add"
                        />
                    </div>
                )}
            </>
        );
    }

    const onUserSelect = (email: string, name: string) => {
        let warningMsg: React.ReactElement = <span>TCC sensitive content is about to be shared with the <b>{name}</b> TechContentApprover.</span>;
        setShowWarning(warningMsg);
        setSelectedUserFunc(email);
    }

    const onSearchTermChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setShowWarning(undefined);
        setShowWarningOptional(undefined);
        setSearchTerm(e.target.value);
    }

    return (
        <>
            <br />
            <div className="search-user-bar">
                <div className="input-holder">
                    <input
                        type="text"
                        id="search-user"
                        placeholder="Search by name or email..."
                        disabled={manageUsersData.getUsersOperation?.isWorking}
                        value={searchTerm}
                        onChange={onSearchTermChange}
                    />
                    <img
                        src={searchIcon}
                        alt="Search"
                        className="icon-small"
                    />
                </div>
                <span className="msg">
                    {showWarning}
                    {showWarningOptional}
                </span>

            </div>
            <div className="results">
                {component}
            </div>
        </>
    );
}

export default SearchTCCUser;